import React, { useState, useRef } from 'react';
import View from 'src/components/view';
import Element from 'src/components/element';
import Toggle from 'src/components/toggle';
import utils from 'src/components/utils';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import Anotacao from 'src/components/anotacao';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogMesasEvento, { getLimiteMesasPorCliente } from 'src/components/dialog_mesas';
import DialogLinksPagamento from 'src/components/dialog_links_pagamento';
import 'src/components/css/pedido.css';
import { useEffect } from 'react';

function getIdPedidoRota() {
  const split = window.location.pathname.split('/');

  if (split.length <= 3) return null;

  const id = parseInt(split[3]);

  return isNaN(id) ? null : id;
}

function Pedido() {
  let defaults = {
    id_filial_entrega: 0,
    id_pedido: 0,
    retirada_terceiro_nome: '',
    retirada_terceiro_cpf: '',
    valor_frete: 0,
    valor_credito: 0,
    valor_descontos: 0,
    valor_total: 0,
    valor_spv: 0,
    valor_produtos: 0,
    usa_spv: false,
    exibir_spv: true,
    parcela: 1,
  };

  let [descontos, setDescontos] = useState({ valor_desconto_spv: 0, valor_desconto_pedido: 0 });
  let [view, setView] = useState({});
  let [pedido, setPedido] = useState(defaults);
  let [meusPagamentos, setMeusPagamentos] = useState([]);
  let [formasEntrega, setFormasEntrega] = useState([]);
  let [crud, setCrud] = useState({ data: defaults, changed: defaults, requireds: {} });
  let [ready, setReady] = useState(false);
  let [empty, setEmpty] = useState(false);
  let [index, setIndex] = useState(0);
  const idPedidoRota = getIdPedidoRota();
  // 0 explícito na rota significa "criar um carrinho novo"
  const create = idPedidoRota === 0;
  const idPedido = idPedidoRota > 0 ? idPedidoRota : 0;
  let user = utils.getUser();
  let [pgtoPix, setPgtoPix] = useState(null);
  let [showDialogQrCodePix, setShowDialogQrCodePix] = useState(false);
  let [isPgtoLinkExterno, setIsPgtoLinkExterno] = useState(false);
  let [barraPrococao, setBarraPrococao] = useState({ ativo: false, texto_exibicao: '', cor_barra: '' });
  let [openDialogMesas, setOpenDialogMesas] = useState(false);
  let [openDialogLinks, setOpenDialogLinks] = useState(false);
  let [mesasReservadas, setMesasReservadas] = useState([]);
  let [itensCarrinho, setItensCarrinho] = useState([]);
  let [infoConsumidor, setInfoConsumidor] = useState(null);
  let ajustandoQuantidadeMesaRef = useRef(false);
  let entregaAutoSelecionadaRef = useRef(false);
  let quantidadeMesaAlteradaRef = useRef(false);
  // Última quantidade de convites observada, para detectar reduções
  let quantidadeConviteAnteriorRef = useRef(null);

  const itemConviteMesa = itensCarrinho.find((item) => {
    const desc = item?.descricao || item?.descricao_produto || '';
    return desc.startsWith('Convite Mesa');
  });
  const hasConviteMesa = Boolean(itemConviteMesa);
  const pagamentoLinkExterno = [].concat(meusPagamentos || []).find((pgt) => pgt && pgt.codigo === 'LINK_EXTERNO');
  const quantidadeConvites = itemConviteMesa?.quantidade;
  const mesasIncompletas = hasConviteMesa && mesasReservadas.length !== quantidadeConvites;

  const [mesaPedidoResumo, setMesaPedidoResumo] = useState([]);

  const listarMesaPedidoResumo = function (p) {
    if (user.codigo_pais !== 'BRA') return;
    utils.execute(crud, 'listarMesasByPedido?id_pedido=' + pedido.id_pedido, null, function (res) {
      setMesaPedidoResumo(res.data);
    });
  };

  // Reduzir a quantidade de convites invalida a seleção de mesas que passa a
  // exceder o novo total — nesse caso ela é descartada e precisa ser refeita.
  useEffect(() => {
    const quantidadeAnterior = quantidadeConviteAnteriorRef.current;

    if (!(quantidadeConvites > 0)) {
      quantidadeConviteAnteriorRef.current = null;
      return;
    }

    quantidadeConviteAnteriorRef.current = quantidadeConvites;

    // Sem redução efetiva não há o que desfazer (inclui o acréscimo de convite)
    if (quantidadeAnterior === null || quantidadeConvites >= quantidadeAnterior) return;

    if (mesasReservadas.length <= quantidadeConvites) return;

    let mensagem = utils.lng(
      'mesas_desmarcadas_reducao_convite',
      'A quantidade de convites ficou menor que as [QTD_MESAS] mesa(s) já selecionada(s), então a seleção foi desfeita. Selecione as mesas novamente.',
    );

    mensagem = mensagem.replace('[QTD_MESAS]', mesasReservadas.length);

    setMesasReservadas([]);
    window.dialog.alert(mensagem);
  }, [quantidadeConvites]);

  useEffect(() => {
    if (mesaPedidoResumo.length == 0 && pedido?.id_pedido > 0) {
      listarMesaPedidoResumo(pedido);
    }
  }, [pedido]);

  let tipos_pedido = [
    {
      descricao: 'VENDA FUTURA',
      constante: 'VENDA_FUTURA',
    },
  ];

  window.processo_atual = 73;

  crud.refresh = function () {
    setCrud(crud);
    setIndex(index + 1);
  };

  crud.allow = function (key) {
    if (user.administrativo) {
      return true;
    }
    return window.access?.[key];
  };

  crud.open = function (value, args) {
    const click = value.click;
    const data = args.data;
    let d = {};
    let url = click.url;

    for (const i in data) {
      const v = data[i];
      const b = '{' + i + '}';
      const c = v + '';

      url = url.replace(b, c);
    }
    d.path = url;
    d.label = click.label;

    window.location.href = url;
  };

  const listarInformacaoPgto = function (p) {
    utils.execute(crud, 'listarInformacaoPgto?id_pedido=' + p.id_pedido, null, function (res) {
      const infos = {};

      for (const i in res.data) {
        const o = res.data[i];

        infos[o.chave] = o.valor;
      }
      p.infos = infos;
    });
  };

  // Identificadores dos atributos de e-commerce gravados na importação Shopify
  const ATRIBUTOS_CONSUMIDOR = {
    LOJA_CONS_SHOPIFY: 'loja_consumidor',
    NOME_CONS_SHOPIFY: 'nome_consumidor',
    EMAIL_CONS_SHOPIFY: 'email_consumidor',
    ENDERECO_CONS_SHOPIFY: 'endereco_consumidor',
    TELEFONE_CONS_SHOPIFY: 'telefone_consumidor',
  };

  const carregarInfoConsumidor = function (p) {
    utils.execute(crud, 'lista_info_ecommerce_by_ped_venda?id_pedido=' + p.id_pedido, null, function (res) {
      const info = {};
      const ids = {};

      for (const i in res.data) {
        const o = res.data[i];
        const campo = ATRIBUTOS_CONSUMIDOR[o.identificador];

        if (campo && (typeof ids[campo] === 'undefined' || o.id > ids[campo])) {
          ids[campo] = o.id;
          info[campo] = o.valor;
        }
      }

      setInfoConsumidor(info);
    });
  };

  const listarFormaEntregas = function (p) {
    const _ks_ = {};

    _ks_.crud = crud;
    _ks_.changed = {
      id_pedido: p.id_pedido,
    };
    _ks_.element = {};
    _ks_.alert = false;
    _ks_.global = true;

    _ks_.complete = function (res) {
      formasEntrega = res.data;

      for (const i in formasEntrega) {
        let frete = formasEntrega[i];

        frete.indisponivel = false;

        if (res.error) {
          frete.indisponivel = true;
        }

        if (frete) {
          frete.valor_frete = frete.preco;
          frete.previsao = '';
          // frete.previsao = frete.prazo > 0 ? utils.lng('chegará_em', 'Chegará em') + ' ' + frete.prazo + ' ' + utils.lng(unidadeTempo, 'dias úteis') : '';
          frete.erro = frete.erro;
        }
      }
      setFormasEntrega(res.data);

      if (pedido.id_entrega) {
        entregaAutoSelecionadaRef.current = false;
      } else if (formasEntrega.length === 1 && !entregaAutoSelecionadaRef.current) {
        entregaAutoSelecionadaRef.current = true;
        setTimeout(() => selecionarEntrega(formasEntrega[0]), 1000);
      }
    };

    _ks_.cfg = {
      url: 'cart/calculateShipping',
      alert: false,
      global: false,
      method: 'POST',
    };
    utils.call(_ks_);
  };

  useEffect(() => {
    if (formasEntrega.length < 1 || itensCarrinho.length < 1) return;

    // Pra evitar chamar essa função várias vezes seguidas.
    if (ajustandoQuantidadeMesaRef.current) return;

    const midiaDigital = formasEntrega.find((entrega) => entrega.descricao.includes('DIGITAL'));
    const conviteMesa = itensCarrinho.find((item) => item.descricao.startsWith('Convite Mesa'));
    const entregaSelecionada = formasEntrega.find((entrega) => entrega.id_entrega === pedido.id_entrega);

    if (!conviteMesa) return;

    if (midiaDigital && entregaSelecionada?.id_entrega !== midiaDigital?.id_entrega) {
      if (entregaAutoSelecionadaRef.current) return;

      entregaAutoSelecionadaRef.current = true;
      selecionarEntrega(midiaDigital);
      return;
    }

    entregaAutoSelecionadaRef.current = false;

    utils.execute(crud, 'listar_limitacao_compra_by_sku?id_sku=' + conviteMesa.id_sku, null, function (res) {
      const result = res.data[0];

      // const dataLiberacaoVendaMesas = result?.data_liberacao_venda_mesas;
      // const limitarVendaMesasListaGraduacoes = result?.limitar_venda_mesas_lista_graduacoes;
      // const limitarMesasClienteMesmaColuna = result?.limitar_mesas_cliente_mesma_coluna;

      const limitePorCliente = getLimiteMesasPorCliente(result);

      if (limitePorCliente <= 0) return;

      if (conviteMesa.quantidade > limitePorCliente) {
        ajustandoQuantidadeMesaRef.current = true;

        window.dialog.alert(
          `Você selecionou uma quantidade de mesas superior ao limite permitido de ${limitePorCliente} mesa(s). A quantidade selecionada será reduzida para o máximo permitido.`,
          null,
          [
            {
              label: utils.lng('confirmar', 'Confirmar'),
              action: () => {
                const _ks_ = {};

                _ks_.crud = crud;
                _ks_.data = conviteMesa;
                _ks_.changed = { quantidade: limitePorCliente };
                _ks_.element = {};
                _ks_.global = true;

                _ks_.complete = function (res) {
                  ajustandoQuantidadeMesaRef.current = false;

                  if (!res.error) {
                    refreshItens();
                  }
                };

                _ks_.onerror = function () {
                  ajustandoQuantidadeMesaRef.current = false;
                };

                _ks_.cfg = {
                  alert: false,
                  global: true,
                  url: 'cart/changeProduct/{id_sku}',
                  method: 'GET',
                };
                utils.call(_ks_);
              },
            },
          ],
        );
      }
    });
  }, [formasEntrega, itensCarrinho]);

  const refreshItens = function () {
    refreshPedido();
    refreshItensCarrinho();
  };

  const refreshItensCarrinho = function () {
    if (window.itensCarrinho) {
      window.itensCarrinho.search();
    }
  };

  const carregarPagamentos = function (p) {
    utils.execute(crud, 'listar_pagamentos_pedido?id_pedido=' + p.id_pedido, null, function (res) {
      meusPagamentos = [];

      if (res.data) {
        meusPagamentos = res.data;
        setMeusPagamentos(res.data);
        if (Array.isArray(meusPagamentos)) {
          pgtoPix = meusPagamentos.find((pgt) => pgt.codigo === 'PIX');
          setPgtoPix(pgtoPix);
          let linkExterno = meusPagamentos.find((pgt) => pgt.codigo === 'LINK_EXTERNO');
          isPgtoLinkExterno = typeof linkExterno != 'undefined' && linkExterno != null && linkExterno.id != null;
          setIsPgtoLinkExterno(isPgtoLinkExterno);
        } else if (meusPagamentos.codigo === 'PIX') {
          pgtoPix = meusPagamentos;
          setPgtoPix(pgtoPix);
        } else if (meusPagamentos.codigo === 'LINK_EXTERNO') {
          isPgtoLinkExterno = true;
          setIsPgtoLinkExterno(isPgtoLinkExterno);
        }

        if (pgtoPix && pgtoPix.is_pendente === true) {
          crud.switchDialogQrCodePix();
        }
      }
    });
  };

  //
  //crud.buscarConfirmacaoPix = false;
  let tentativaConfirmacaoPix = 0;
  let [falhaConfirmacaoPix, setFalhaConfirmacaoPix] = useState(false);
  let [isPagamentoPixAprovado, setIsPagamentoPixAprovado] = useState(false);

  const buscaConfirmacaoPix = function () {
    crud.buscarConfirmacaoPix = true;
    tentativaConfirmacaoPix = 0;
    setTimeout(() => requestConfirmacaoPix(), 30000);
  };

  const requestConfirmacaoPix = function () {
    tentativaConfirmacaoPix += 1;
    utils.execute(crud, 'pix/getConfirmacaoPagamento/' + pedido.id_pedido, null, function (res) {
      if (res.data && res.data.pagamentoConfirmado === true) {
        setIndex(index + 1);
        setIsPagamentoPixAprovado(true);
        setTimeout(() => {
          window.location.href = '/carrinho/pedido/' + pedido.id_pedido;
        }, 3000);
      } else {
        if (tentativaConfirmacaoPix <= 54 && showDialogQrCodePix && crud.buscarConfirmacaoPix) {
          setTimeout(() => requestConfirmacaoPix(), 5000);
        } else {
          setFalhaConfirmacaoPix(true);
        }
      }
    });
  };

  const refreshPedido = function () {
    const idPedidoAtual = pedido.id_pedido > 0 ? pedido.id_pedido : idPedido;

    utils.execute(crud, 'encontrarPedido?id_pedido=' + idPedidoAtual, null, function (res) {
      setEmpty(true);

      for (const i in res.data) {
        setEmpty(false);

        const p = res.data[i];

        p.cliente = {};
        p.cliente.nome = p.nome_cliente;
        p.cliente.id = p.id_cliente;

        p.filialRetirada = {};

        if (p.id_filial_retirada > 0) {
          p.filialRetirada.id = p.id_filial_retirada;
          p.filialRetirada.nome = p.nome_filial_retirada;
        } else {
          p.filialRetirada.id = p.id_filial;
          p.filialRetirada.nome = p.filial;
        }

        if (p.valor_desconto_pedido > 0) {
          descontos.valor_desconto_pedido = p.valor_desconto_pedido;
        }

        if (p.valor_desconto_spv > 0) {
          descontos.valor_desconto_spv = p.valor_desconto_spv;
        }

        p.parcela = 1;

        listarInformacaoPgto(p);
        carregarPagamentos(p);

        if (p.tipo_pedido === 'SHOPIFY') {
          carregarInfoConsumidor(p);
        }

        pedido = p;
        setPedido(p);
        if (p.constante_status === 'COMPRANDO') {
          listarFormaEntregas(p);
        }
      }
      if (res.data.length <= 0) {
        window.location.href = '/meus_pedidos';
      }
    });
  };

  const checkBarraPromocao = function () {
    utils.execute(crud, 'encontrarConfigBarraPromocao', null, function (res) {
      if (res.data && res.data.length > 0) {
        barraPrococao = res.data[0];
        setBarraPrococao(barraPrococao);
      }
    });
  };

  if (!ready) {
    setReady(true);

    utils.execute(crud, 'HubCondicaoPagamento', ['id', 'codigo', 'nome']);

    checkBarraPromocao();

    if (create) {
      const _ks_ = {};

      _ks_.crud = crud;
      _ks_.changed = {};
      _ks_.element = {};

      _ks_.complete = function () {
        refreshPedido();
      };

      _ks_.cfg = {
        url: 'cart/create',
        method: 'POST',
      };
      utils.call(_ks_);
    } else {
      refreshPedido();
    }
  }

  crud.refreshPedido = refreshPedido;
  crud.selecionarCliente = function (_el, b) {
    pedido.nome_cliente = b.cliente.nome;
    pedido.id_cliente = b.cliente.id;
    pedido.codigo_mundial = b.cliente.codigo;

    setIndex(index + 1);

    const _ks_ = {};

    _ks_.crud = crud;
    _ks_.changed = pedido;
    _ks_.element = {};

    _ks_.complete = function () {
      refreshItens();
      crud.refresh();
    };

    _ks_.cfg = {
      url: 'cart/changeClient',
      method: 'POST',
    };
    utils.call(_ks_);
  };

  crud.onsearch = function (args) {
    crud.changed.query = args.query;
  };

  const selecionarTipoVenda = function (b) {
    if (pedido.id_pedido > 0) {
      const _ks_ = {};

      _ks_.global = true;
      _ks_.crud = crud;
      _ks_.changed = {
        tipo: b.constante,
      };
      _ks_.element = {};

      _ks_.complete = function () {
        if (crud) {
          setIndex(index + 1);
          refreshPedido();
        }
      };

      _ks_.cfg = {
        alert: false,
        url: 'cart/changeType',
        method: 'POST',
      };
      utils.call(_ks_);
    }
  };

  const aplicarDescontos = function () {
    if (pedido.id_pedido > 0) {
      const _ks_ = {};

      _ks_.global = true;
      _ks_.crud = crud;
      _ks_.changed = descontos;
      _ks_.element = {};

      _ks_.complete = function () {
        if (crud) {
          setIndex(index + 1);
          refreshPedido();
        }
      };

      _ks_.cfg = {
        alert: false,
        url: 'cart/complement',
        method: 'POST',
      };
      utils.call(_ks_);
    }
  };

  const onChangePercentualDesconto = function (target, key, val) {
    let base = pedido[target];
    let calc = (base * val) / 100;

    descontos[key] = calc.toFixed(2);

    setIndex(index + 1);
  };

  const onChangeDesconto = function (key, val) {
    descontos[key] = val;

    descontos.percentual_desconto_pedido = 0;
    descontos.percentual_desconto_spv = 0;

    setIndex(index + 1);
  };

  const selecionarEntrega = function (b) {
    if (pedido.id_pedido > 0) {
      if (b.erro != null && b.erro != '') {
        let actions = [];
        actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => {} });

        if (window.dialog) {
          window.dialog.alert(b.erro, null, actions);
        }
      } else {
        pedido.id_entrega = b.id_entrega;
        pedido.constante_entrega = b.constante;
        setIndex(index + 1);

        const _ks_ = {};

        _ks_.global = true;
        _ks_.crud = crud;
        _ks_.changed = pedido;
        _ks_.element = {};

        _ks_.complete = function (res) {
          if (!res.error) {
            refreshItens();
          }
        };

        _ks_.global = true;
        _ks_.cfg = {
          alert: false,
          global: false,
          url: 'cart/changeDelivery',
          method: 'POST',
        };
        utils.call(_ks_);
      }
    }
  };

  crud.consultarCEP = function () {
    const _ks_ = {};

    _ks_.crud = {};
    _ks_.changed = { cep: pedido.cep };
    _ks_.element = {};

    _ks_.complete = function (res) {
      if (res.data) {
        for (const i in res.data) {
          if (typeof res.data[i] !== 'object') {
            pedido[i] = res.data[i];
          }
        }
        setPedido(pedido);
        setIndex(index + 1);
      }
    };

    _ks_.cfg = {
      alert: false,
      url: 'consultarCEP',
      method: 'GET',
    };
    utils.call(_ks_);
  };

  crud.selecionarProduto = function (_el, args) {
    const sku = args.produto;

    if (sku) {
      const _ks_ = {};

      _ks_.crud = {};
      _ks_.global = true;
      _ks_.changed = { quantidade: 1 };
      _ks_.element = {};

      _ks_.complete = function () {
        refreshPedido();

        if (window.itensCarrinho) {
          window.itensCarrinho.search();
        }
      };

      _ks_.cfg = {
        url: 'cart/changeProduct/' + sku,
        global: true,
      };
      utils.call(_ks_);
    }
  };

  crud.switchDialogQrCodePix = function () {
    showDialogQrCodePix = !showDialogQrCodePix;
    setShowDialogQrCodePix(showDialogQrCodePix);
    if (showDialogQrCodePix) {
      buscaConfirmacaoPix();
    } else {
      crud.buscarConfirmacaoPix = false;
    }
  };

  const terceiro = {
    name: 'terceiro',
    elements: {
      nome_pessoa_retirar: { type: 'text', label: 'Nome', cols: 12, required: utils.getPaisUser() === 'BRA' },
      documento_pessoa_retirar: { type: 'text', label: 'Documento', cols: 12, required: utils.getPaisUser() === 'BRA' },
      dh_retirada: { type: 'date', label: 'Data retirada', cols: 12, required: utils.getPaisUser() === 'BRA' },
      ok: {
        type: 'button',
        label: 'OK',
        cols: 2,
        styleClass: 'ui-input-button',
        rendered: false,
        click: {
          url: 'cart/changeDelivery',
          method: 'POST',
          params: {
            tipoEntrega: 'RETIRAR_FILIAL',
          },
        },
      },
    },
  };

  const acoes_topo = {
    space: 6,
    elements: {
      orcamento: {
        type: 'button',
        label: 'Gerar pedido',
        space: 3,
        rendered: pedido.constante_status === 'ORCAMENTO',
        style: { marginLeft: '20px' },
        click: {
          prompt: 'Pedidos em aberto serão encerados, deseja continuar?',
          url: 'cart/{id_pedido}/continue',
          method: 'PUT',
          redirect: '/carrinho/pedido',
        },
      },
      convite: {
        type: 'button',
        label: 'Gerar Convite',
        rendered: pedido.convite === true,
        disabled: "${@this.constante_status === 'AGUARDANDO_PAGAMENTO'}",
        space: 2,
        style: { marginLeft: '20px' },
        click: {
          url: 'convite_convensao/print/{id_pedido}.pdf',
          method: 'GET',
          download: true,
          fileName: 'convite.pdf',
          send: false,
        },
      },
      link_gerado: {
        type: 'button',
        label: 'Gerenciar Links',
        style: { marginLeft: '20px' },
        rendered: isPgtoLinkExterno === true,
        space: 2,
        click: () => setOpenDialogLinks(true),
      },
    },
  };

  const endereco = {
    name: 'endereco',
    disabled: true,
    elements: {
      cep: {
        type: 'text',
        mask: '99.999-999',
        required: true,
        label: 'CEP',
        cols: 3,
        min: 8,
        change: { action: 'consultarCEP' },
      },
      bairro: { type: 'text', label: 'Bairro', cols: 6, required: true },
      numero: { type: 'text', label: 'Número', cols: 3, required: true },
      cidade: { type: 'text', label: 'Cidade', cols: 6, required: true },
      estado: { type: 'text', label: 'Estado', cols: 6, required: true },
      logradouro: { type: 'text', label: 'Rua', cols: 6, required: true },
      complemento: { type: 'text', label: 'Complemento', cols: 6, required: true },
      ok: {
        rendered: false,
        type: 'button',
        label: 'Ok',
        cols: 2,
        click: {
          url: 'cart/changeDeliveryAddress',
          redirect: true,
          method: 'POST',
        },
      },
    },
  };
  const confirmar = {
    name: 'irPagamento',
    style: { float: 'right' },
    elements: {
      confirmar_pagamento: {
        rendered: pedido.quantidade > 0,
        disabled: !pedido.constante_entrega || mesasIncompletas,
        theme: 'success',
        type: 'button',
        label: utils.lng('confirmar_pagamento', 'Selecionar pagamento'),
        click: {
          url: 'cart/cartValidate',
          method: 'POST',
          redirect: '/carrinho/pagamento',
        },
      },
    },
  };

  const filial = {
    name: 'filialRetirada',
    id: 'filialRetirada',
    label: utils.lng('filial_retirada', 'Filial retirada'),
    type: 'entity',
    add: false,
    trash: false,
    readyOnly: true,
    disabled: "${crud.allow('EDITAR_FILIAL') === false}",
    showLabel: false,
    entity: 'Filial',
    change: {
      url: 'cart/changeDeliveryLocal',
      method: 'POST',
      redirect: true,
      global: true,
    },
  };

  const cliente = {
    name: 'cliente',
    id: 'cliente',
    selectLabel: utils.lng('btn_selecione', 'SELECIONE'),
    label: utils.lng('nome_cliente', 'Cliente'),
    type: 'entity',
    disabled: "${!crud.allow('EDITAR_CLIENTE')}",
    add: false,
    trash: false,
    entity: 'Cliente',
    list: {
      url: 'listarClientesCarrinho',
    },
    change: {
      global: true,
      action: 'selecionarCliente',
    },
  };

  const itens = {
    elements: {
      itens_search: {
        style: { paddingBottom: '10px' },
        elements: {
          produto: {
            name: 'produto',
            size: 50,
            auto: false,
            cols: 3,
            widgetVar: 'itensCarrinho',
            label: utils.lng('pesquisar', 'Pesquisar'),
            disabled: pedido.id_cliente === undefined,
            itemLabel: 'pesquisa',
            itemValue: 'id_sku',
            inputIcon: 'fa fa-search',
            styleClass: 'ui-search',
            fields: ['pesquisa'],
            type: pedido.id_cliente === undefined ? 'text' : 'complete',
            columns: {
              avatar: { type: 'img' },
              descricao: {},
              valor: {
                type: 'span',
                format: 'money',
                field: 'valor',
                style: { paddingBottom: '10px', color: '#E2E9F0', fontSize: '20px', fontWeight: 'bold' },
              },
            },
            list: {
              url: 'listarProdutosCarrinho',
            },
            change: {
              action: 'selecionarProduto',
            },
            keypress: {
              action: 'onsearch',
            },
          },
          acoes_carrinho: {
            cols: 9,
            layout: 'inline',
            style: { textAling: 'right' },
            elements: {
              ver_orcamentos: {
                rendered: (user.tipo + '').indexOf('ADMINISTRATIVO') > -1,
                disabled: pedido.id_cliente === undefined,
                type: 'button',
                label: utils.lng('ver_orcamento', 'VER ORÇAMENTOS'),
                click: {
                  redirect: '/orcamentos_cliente/' + pedido.id_cliente,
                  validate: false,
                },
              },
              limpar_carrinho: {
                type: 'button',
                label: utils.lng('cancela_ped', 'CANCELAR PEDIDO'),
                theme: 'secondary',
                click: {
                  prompt: utils.lng('prompt_cancel_pedido', 'Tem certeza que deseja cancelar seu pedido?'),
                  url: 'cart/cancel',
                  method: 'POST',
                  validate: false,
                },
              },
              ir_catalogo: {
                type: 'button',
                label: 'Acessar catálogo',
                click: {
                  validate: false,
                  redirect: '/carrinho',
                },
              },
            },
          },
        },
      },
      itens_grid: {
        name: 'itens',
        type: 'list',
        layout: 'table',
        search: false,
        widgetVar: 'itensCarrinho',
        controls: false,
        size: 500,
        add: false,
        list: {
          url: 'listarItensCarrinho?id_pedido={id_pedido}',
          send: false,
          complete: function (res) {
            if (res && res.data) {
              setItensCarrinho(res.data);
            }
          },
        },
        columns: {
          avatar: {
            upload: false,
            type: 'img',
            sort: false,
            click: {
              redirect: '/carrinho/produto/${@this.id_sku}',
            },
          },
          info: {
            label: utils.lng('descricao', 'Descrição'),
            sort: false,
            elements: {
              descricao: { field: 'descricao', type: 'span' },
              detalhe: { field: 'detalhe', type: 'span', sort: false },
            },
          },
          quantidade: {
            label: 'Quantidade',
            rowEdit: true,
            type: 'spinner',
            disabled: '${!@this.permite_editar_item}',
            numeric: true,
            click: false,
            sort: false,
            blur: {
              url: 'cart/changeProduct/{id_sku}',
              method: 'GET',
              rollback: true,
              complete: () => {
                delete crud.changed.quantidade;

                refreshItens();
              },
            },
          },
          valor_total_itens: {
            label: utils.lng('valor_item_carrinho', 'Valor'),
            type: 'span',
            sort: false,
            elements: {
              valor_item_carrinho: {
                // value: '${utils.money(@this.valor_item_carrinho)}',
                value: pedido.exibir_centavos
                  ? '${utils.money(@this.valor_item_carrinho)}'
                  : '${utils.moneyCents(@this.valor_item_carrinho)}',
                type: 'span',
                format: 'money',
                bold: true,
              },
              valor_moeda_secundaria: {
                value: "${utils.customMoney('₲',@this.valor_custo)}",
                rendered: '${@this.exibir_valor_moeda_secundaria}',
                type: 'span',
                bold: true,
              },
            },
          },
          valor_spv: { rendered: '${@this.exibir_spv}', label: 'SPV', format: 'money', bold: true, sort: false },
          remove: {
            type: 'icon',
            icon: 'fa fa-trash',
            sort: false,
            click: {
              url: 'cart/delProduct/{id_sku}',
              method: 'GET',
              complete: refreshPedido,
            },
          },
        },
      },
    },
  };

  const itensSimples = {
    name: 'itens',
    type: 'list',
    layout: 'table',
    controls: false,
    search: false,
    size: 500,
    add: false,
    list: {
      url: 'listarItensCarrinho?id_pedido={id_pedido}',
      send: false,
    },
    columns: {
      avatar: { upload: false, type: 'img' },
      info: {
        label: 'Descrição',
        sort: false,
        elements: {
          descricao: { field: 'descricao', type: 'span' },
          detalhe: { field: 'detalhe', type: 'span', sort: false },
        },
      },
      quantidade: {
        label: 'Quantidade',
      },
      valor_item_carrinho: { label: 'Valor', type: 'span', format: 'money', bold: true },
    },
  };

  const textoConsumidor = function (valor) {
    if (valor === null || typeof valor === 'undefined') return '';

    const texto = (valor + '').trim();

    if (texto === 'null' || texto === 'undefined') return '';

    return texto.replaceAll('${', '$ {').replaceAll('#{', '# {');
  };

  const consumidorShopify = {
    name: 'consumidor',
    type: 'list',
    layout: 'table',
    search: false,
    controls: false,
    add: false,
    data: [
      {
        loja_consumidor: textoConsumidor(infoConsumidor?.loja_consumidor),
        nome_consumidor: textoConsumidor(infoConsumidor?.nome_consumidor),
        email_consumidor: textoConsumidor(infoConsumidor?.email_consumidor),
        endereco_consumidor: textoConsumidor(infoConsumidor?.endereco_consumidor),
        telefone_consumidor: textoConsumidor(infoConsumidor?.telefone_consumidor),
      },
    ],
    columns: {
      loja_consumidor: { label: utils.lng('loja_consumidor', 'Loja Consumidor'), type: 'span' },
      nome_consumidor: { label: utils.lng('nome_consumidor', 'Nome do Consumidor'), type: 'span', bold: true },
      email_consumidor: { label: utils.lng('email_consumidor', 'E-mail'), type: 'span' },
      endereco_consumidor: { label: utils.lng('endereco_consumidor', 'Endereço'), type: 'span' },
      telefone_consumidor: { label: utils.lng('telefone_consumidor', 'Telefone'), type: 'span' },
    },
  };

  const timeline = {};

  if (
    '|ERRO_PAGAMENTO|ERRO_FATURAMENTO|CANCELADO|AGUARDANDO_CANCELAMENTO|PRE_VENDA_PENDENTE|'.indexOf(
      pedido.constante_status,
    ) < 0
  ) {
    timeline.criado = { label: utils.lng('pedido_realizado', 'Pedido realizado'), date: pedido.dh_registro };
    timeline.aguardando_pgto = {
      label: utils.lng('aguardando_pagamento', 'Aguardando Pagamento'),
      date: pedido.dh_pagamento,
      options: true,
      myIcon:
        pedido.dh_pagamento && pgtoPix && !pgtoPix.is_pendente ? 'fas fa-check-circle' : 'fas fa-exclamation-circle',
    };
    timeline.pago = { label: utils.lng('pagamento_aprovado', 'Pagamento aprovado'), date: pedido.dh_pagamento };
    timeline.nota = { label: utils.lng('nf_emitida', 'Nota fiscal emitida'), date: pedido.dh_faturamento };
    timeline.enviado = {
      label: utils.lng('produto_enviado', 'Produto(s) <br> enviado / entregue'),
      date: pedido.dh_entrega,
    };
  } else {
    timeline.erro = { label: pedido.descricao_status, date: null };
  }

  window.crud = crud;

  return (
    <View name="carrinho">
      {!(pedido.id_pedido > 0) && (
        <div className="ui-pagamento">
          <div className="ui-topo ui-shadow ui-border ui-white">
            <div className="ui-col ui-col-2 ui-padding ui-color-red ui-bold ui-item-select">
              {utils.lng('meu_carrinho', 'Meu carrinho')}
            </div>
          </div>
          <div className="ui-content">
            <div className="ui-shadow ui-timeline ui-white ui-grid ui-table">
              <div className="ui-col ui-tl-item ui-col-auto ui-padding ui-big-label ui-empty-cart">
                {empty && (
                  <>
                    <div className="ui-center ui-padding">{utils.lng('carrinho_vazio', 'Seu carrinho esta vazio')}</div>
                    <div className="ui-center ui-padding">
                      <a href="/carrinho">{utils.lng('ir_para_catalogo', 'Ir para o catálogo')}</a>
                    </div>
                  </>
                )}
                {!empty && (
                  <>
                    <div className="ui-center ui-padding">{utils.lng('carregando', 'Carregando...')}</div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {pedido.id_pedido > 0 && (
        <div className="ui-pagamento">
          <div className="ui-topo ui-shadow ui-border ui-white">
            <div
              id="status_pedido"
              className="ui-col ui-col-4 ui-padding ui-color-green ui-bold ui-item-select"
              style={{ width: '17%' }}
            >
              {pedido.constante_status === 'COMPRANDO' && (
                <>
                  <span
                    className="ui-circle ui-color-green ui-step"
                    style={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '34px',
                      height: '34px',
                      borderRadius: '50%',
                      backgroundColor: '#a1c7a7',
                      marginRight: '8px',
                    }}
                  >
                    1
                  </span>
                </>
              )}
              {pedido.descricao_status == 'Pedido em aberto'
                ? utils.lng('lbl_pedido_aberto', 'Pedido em aberto')
                : pedido.descricao_status}
            </div>
          </div>
          <div className="ui-content">
            {pedido.constante_status !== 'COMPRANDO' && (
              <>
                <div id="status_pedido_numero" className="ui-big-label" style={{ with: '300px' }}>
                  {utils.lng('descricao_status', 'Status do pedido')} {pedido.numero_pedido}
                  <Element data={pedido} crud={crud} value={acoes_topo}></Element>
                </div>
                <div className="ui-shadow ui-timeline ui-white ui-grid ui-table">
                  {Object.entries(timeline).map((ob) => (
                    <div
                      className={
                        'ui-tl-' +
                        ob[0] +
                        ' ui-col ui-tl-item ui-col-auto ui-padding ' +
                        (ob[1].date ? 'ui-tl-sel' : '')
                      }
                    >
                      <div className="ui-tl-date">{ob[1].date}</div>
                      <div className="ui-tl-icon">
                        <i
                          className={ob[1].myIcon ? ob[1].myIcon : !ob[1].date ? 'fa fa-circle' : 'fas fa-check-circle'}
                        ></i>
                      </div>
                      <div className="ui-tl-label">
                        <span dangerouslySetInnerHTML={{ __html: ob[1].label }}></span>
                      </div>
                      {ob[1].options === true && (
                        <>
                          {pgtoPix && pgtoPix.codigo === 'PIX' && pgtoPix.is_pendente === true && (
                            <>
                              <div className="ui-tl-option">
                                <Button
                                  id="btnShowDialogPix"
                                  onClick={() => {
                                    crud.switchDialogQrCodePix()(true);
                                  }}
                                  variant="contained"
                                  color="primary"
                                >
                                  {utils.lng('visualizar_qrcode', 'VISUALIZAR QR CODE')}
                                </Button>
                              </div>
                            </>
                          )}
                        </>
                      )}
                      <div className="ui-tl-bar"></div>
                    </div>
                  ))}
                </div>
                <div className="ui-big-label">{utils.lng('resumo_pedido', 'Resumo do pedido')}</div>
                <div className="ui-shadow ui-white ui-grid ui-table">
                  <div className="ui-col ui-col-4 ui-padding">
                    <div id="data_do_pedido" className="ui-small-label">
                      Data do pedido:
                      <br /> {pedido.dh_registro}
                    </div>
                  </div>
                  {pedido.link_nfe && (
                    <div className="ui-col ui-col-4 ui-padding">
                      <div id="chave_nfe" className="ui-small-label">
                        <i className="fa fa-file"></i>
                        <a
                          style={{ textDecoration: 'underline', paddingTop: '15px', marginLeft: '15px' }}
                          href={pedido.link_nfe}
                          target="_blank"
                        >
                          Ver nota fiscal
                        </a>
                      </div>
                    </div>
                  )}
                  <div className="ui-col ui-col-4 ui-border-left ui-padding">
                    <div className="ui-small-label">
                      {utils.lng('valor_total', 'Valor total do pedido: ')} <br /> {utils.money(pedido.valor_total)}
                    </div>
                  </div>
                  {mesaPedidoResumo.length > 0 && (
                    <div className="ui-col ui-col-4 ui-border-left ui-padding">
                      <div className="ui-small-label">
                        {utils.lng('mesas', 'Mesas: ')} <br /> {mesaPedidoResumo.map((m) => m.codigo).join(', ')}
                      </div>
                    </div>
                  )}
                </div>
                {pedido.cep && (
                  <>
                    <div className="ui-big-label">
                      {pedido.retirar_filial ? utils.lng('retirada', 'Retirada') : utils.lng('envio', 'Envio')}
                    </div>
                    <div className="ui-shadow ui-white ui-grid ui-table">
                      <div className="ui-col ui-col-6 ui-padding">
                        <div id="envio_do_pedido" className="ui-small-label">
                          {pedido.logradouro}, {pedido.bairro ? pedido.bairro : ''}, {pedido.numero},{' '}
                          {pedido.complemento} <br /> {utils.lng('cep', 'CEP')}:{' '}
                          {utils.applyMask(pedido.cep, '99.999-999')}, {pedido.cidade}-{pedido.estado}
                        </div>
                      </div>
                      {pedido.codigo_rastreio && (
                        <div className="ui-col ui-upper ui-col-6 ui-padding">
                          <div id="cod_rastreio" className="ui-small-label">
                            <b>
                              {utils.lng('codigo_rastreio', 'Código de rastreio')} {pedido.descricao_entrega}:{' '}
                            </b>{' '}
                            <br />
                            {pedido.codigo_rastreio}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="ui-big-label">{utils.lng('info_de_pagamento', 'Informações de pagamento')}</div>
                <div className="ui-resumo-minhas-formas">
                  {Object.entries(meusPagamentos).map((el, i) => (
                    <div
                      id={'lista_pagamento_' + i}
                      className="ui-shadow ui-white ui-grid ui-grid-pgtos ui-grid-meus-pgtos"
                    >
                      <>
                        <div className={'ui-col ui-col-1 ui-item-pgto ui-item-pgto-' + i}>{i + 1}</div>
                        <div className="ui-col ui-col-2 ui-padding">
                          <div className="ui-small-label">Valor</div>
                          <div id={'valor_pagamento_' + i} className="ui-value ui-bold ui-color-green ">
                            {utils.money(el[1].valor)}
                          </div>
                        </div>
                        <div id={'forma_pagamento_' + i} className="ui-col ui-col-6 ui-padding ui-bold ui-big">
                          {el[1].nome}
                        </div>
                        <div className="ui-col ui-col-2 ui-padding ui-pg-info">
                          {el[1].info && <div dangerouslySetInnerHTML={{ __html: el[1].info }}></div>}
                          {el[1].icone && <i className={el[1].icone}></i>}
                        </div>
                      </>
                    </div>
                  ))}
                </div>
                {pedido.infos && (
                  <>
                    {pedido.infos && pedido.infos.BOLETO_CODIGO_BARRAS && (
                      <>
                        <div className="ui-shadow ui-boleto ui-border ui-radius ui-center ui-white ui-grid ui-table">
                          <div className="ui-col ui-col-12 ui-padding">
                            <br />
                            <div>
                              <i className="fa fa-barcode"></i>
                            </div>
                            <div className="ui-barcode" id="barcode">
                              {pedido.infos.BOLETO_CODIGO_BARRAS}
                            </div>
                            <br />
                            <a
                              id="copy_barcode"
                              className="ui-button-link"
                              onClick={() => {
                                utils.copy('barcode');
                              }}
                            >
                              {utils.lng('copiar_numero_pagamento', 'COPIAR NÚMERO PARA PAGAMENTO')}
                            </a>
                            <br />
                            <br />
                            <a className="ui-button-link" href={pedido.infos.BOLETO_URL} target="_blank">
                              {utils.lng('baixar_boleto', 'BAIXAR BOLETO')}
                            </a>
                            <br />
                            <br />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
                <div className="ui-big-label">{utils.lng('detalhes_pedido', 'Detalhes do pedido')}</div>
                <div className="ui-shadow ui-white ui-grid ui-table overflow-auto">
                  <div className="ui-col ui-col-12 ui-padding">
                    <Element value={itensSimples} crud={crud} data={pedido} view={view}></Element>
                  </div>
                </div>

                {pedido.tipo_pedido === 'SHOPIFY' && (
                  <>
                    <div className="ui-big-label">{utils.lng('detalhes_cliente', 'Detalhes do cliente')}</div>
                    <div className="ui-shadow ui-white ui-grid ui-table overflow-auto">
                      <div className="ui-col ui-col-12 ui-padding">
                        <Element
                          key={'consumidor_' + pedido.id_pedido + '_' + (infoConsumidor ? 'ok' : 'load')}
                          value={consumidorShopify}
                          crud={crud}
                          data={pedido}
                          view={view}
                        ></Element>
                      </div>
                    </div>
                  </>
                )}
                <div
                  id="totais_do_pedido"
                  style={{ marginTop: '20px' }}
                  className="ui-card ui-shadow ui-card-resumo ui-white ui-nopadding ui-theme"
                >
                  <div className="ui-card-title">{utils.lng('valor_total', 'Totais do pedido')}</div>
                  <div className="ui-card-data">
                    <div className=" ui-white ui-grid">
                      <div id="valor_dos_itens" className="ui-col ui-col-12 ui-padding">
                        <div className="ui-small-label">{utils.lng('valor', 'Valor dos itens')}</div>
                        <div id="valor_produtos" className="ui-value ui-bold ui-color-blue">
                          {pedido.exibir_centavos
                            ? utils.money(pedido.valor_produtos)
                            : utils.moneyCents(pedido.valor_produtos)}
                        </div>
                      </div>
                      {pedido.exibir_valor_moeda_secundaria && (
                        <>
                          <div className="ui-col ui-col-12 ui-padding">
                            <div className="ui-small-label">{pedido.descricao_moeda_secundaria}</div>
                            <div id="valor_moeda_secundaria" className="ui-value ui-bold ui-color-blue">
                              {utils.customMoney('₲', pedido.valor_custo)}
                            </div>
                          </div>
                        </>
                      )}
                      {pedido.exibir_spv && (
                        <>
                          <div className="ui-col ui-col-12 ui-padding">
                            <div className="ui-small-label">{utils.lng('valor_spv', 'SPV')}</div>
                            <div id="valor_spv" className="ui-value ui-bold ui-color-blue">
                              {utils.money(pedido.valor_spv)}
                            </div>
                          </div>
                        </>
                      )}
                      <div className="ui-col ui-col-12 ui-padding">
                        <div className="ui-small-label">{utils.lng('frete', 'Frete')}</div>
                        <div id="valor_frete" className="ui-value ui-bold ui-color-green">
                          {pedido.valor_frete <= 0 && <>{utils.lng('gratis', 'Grátis')}</>}
                          {pedido.valor_frete > 0 && <>{utils.money(pedido.valor_frete)}</>}
                        </div>
                      </div>
                      <div className="ui-col ui-col-12 ui-padding">
                        <div className="ui-small-label">{utils.lng('descontos', 'Descontos')}</div>
                        <div id="valor_desconto" className="ui-value ui-bold ui-color-red">
                          {utils.money(pedido.valor_descontos)}
                        </div>
                      </div>
                      <div className="ui-col ui-col-12 ui-padding">
                        <div className="ui-small-label">{utils.lng('valor_pedido', 'Valor Total')}</div>
                        <div id="valor_total_pedido" className="ui-value ui-bold ui-color-green ">
                          {utils.money(pedido.valor_total)}
                        </div>
                      </div>
                      <div className="ui-col ui-col-12 ui-padding">
                        <div className="ui-small-label">
                          {utils.lng(
                            'pontos_pedido',
                            'Pontos do pedido (O ponto será gerado somente após a emissão da(s) Nota(s) e baixa dos respectivo(s) título(s))',
                          )}
                        </div>
                        <div id="pontos_pedido" className="ui-value ui-bold ui-color-blue">
                          {pedido.pontos_pedido}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="anotacoes_do_pedido"
                  style={{ marginTop: '20px' }}
                  className="ui-card ui-shadow ui-card-resumo ui-white ui-nopadding ui-theme"
                >
                  <div className="ui-card-title">{utils.lng('anotacoes_pedido', 'Anotações do pedido')}</div>
                  {pedido.id_pedido > 0 && (
                    <>
                      <Anotacao add={true} id={pedido.id_pedido} entidade="HubPedidoVenda" view={view}></Anotacao>
                    </>
                  )}
                </div>
              </>
            )}

            {barraPrococao && barraPrococao.ativo && (
              <div
                className="ui-catalogo-barra-promocao ui-catalogo-barra-promocao-pedido"
                style={{
                  backgroundColor: barraPrococao.cor_barra ? barraPrococao.cor_barra : '#F00',
                  color: barraPrococao.cor_caracteres ? barraPrococao.cor_caracteres : '#FFF',
                }}
              >
                <span>{barraPrococao.texto_exibicao}</span>
              </div>
            )}

            {pedido.constante_status === 'COMPRANDO' && (
              <>
                <div className="ui-big-label" style={{ marginTop: '50px' }}>
                  {utils.lng('nome_cliente', 'Cliente')}
                </div>
                <div className="ui-shadow ui-white ui-grid ui-table">
                  <div className="ui-col ui-col-3 ui-padding client-input">
                    <Element value={cliente} crud={crud} data={pedido} view={view}></Element>
                  </div>
                  <div className="ui-col ui-col-2 ui-border-left ui-padding cod-mund">
                    <div id="codigo_mundial" className="ui-small-label">
                      {utils.lng('cod_mundial', 'Cód. Mundial')}:<br /> {pedido.codigo_mundial}
                    </div>
                  </div>
                  <div className="ui-col ui-col-2 ui-border-left ui-padding client-ped">
                    <div id="pedido_cidade" className="ui-small-label">
                      {utils.lng('cidade_ped', 'Cidade')}:<br /> {pedido.cidade} / {pedido.estado}
                    </div>
                  </div>
                  <div className="ui-col ui-col-3 ui-border-left ui-padding">
                    <Element disabled={false} value={filial} crud={crud} data={pedido} view={view}></Element>
                  </div>
                </div>
                <div className="ui-big-label">{utils.lng('pedido', 'Pedido')}</div>
                <div id="informacoes_pedido" className="ui-shadow ui-white ui-grid ui-table">
                  <div className="ui-col ui-col-12 ui-padding">
                    <Element value={itens} crud={crud} data={pedido} view={view}></Element>
                  </div>
                </div>
                <div className="ui-big-label"></div>
                <div className="ui-grid ui-table">
                  <div className="ui-col ui-bloco-entrega ui-col-8">
                    <>
                      {hasConviteMesa && (
                        <>
                          <div className="ui-card ui-shadow ui-white ui-nopadding" style={{ marginBottom: '20px' }}>
                            <div className="ui-card-title">
                              {utils.lng('selecionar_local_mesa', 'Selecionar local da mesa')}
                            </div>
                            <div className="ui-card-data">
                              <div className="ui-col ui-col-12">
                                <div
                                  style={{
                                    padding: '10px 20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '16px',
                                  }}
                                  className={
                                    'ui-tipo-venda ui-col ui-col-12 ' +
                                    (index % 2 === 0 ? 'ui-row-event' : 'ui-row-odd')
                                  }
                                >
                                  <Button onClick={() => setOpenDialogMesas(true)} variant="contained" color="primary">
                                    {mesasReservadas.length > 0
                                      ? utils.lng('alterar_mesas', 'ALTERAR MESAS')
                                      : utils.lng('selecionar_mesas', 'SELECIONAR MESAS')}
                                  </Button>
                                  {mesasReservadas.length > 0 && (
                                    <span style={{ fontWeight: 'bold', fontSize: '0.95rem' }}>
                                      {utils.lng('mesas_reservadas', 'Mesas reservadas')}:{' '}
                                      {mesasReservadas.map((m) => m.codigo).join(', ')}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                    {(user.tipo + '').indexOf('ADMINISTRATIVO') > -1 && (
                      <>
                        <div className="ui-card ui-shadow ui-white ui-nopadding" style={{ marginBottom: '20px' }}>
                          <div className="ui-card-title">Qual o tipo do pedido?</div>
                          <div className="ui-card-data">
                            <div id="tipos_pedido" className="ui-col ui-col-12">
                              {tipos_pedido.map((i, index) => (
                                <>
                                  <div
                                    onClick={() => {
                                      selecionarTipoVenda(i);
                                    }}
                                    style={{ padding: '10px 20px' }}
                                    className={
                                      'ui-tipo-venda ui-pointer ui-col ui-col-12 ' +
                                      (index % 2 === 0 ? 'ui-row-event' : 'ui-row-odd')
                                    }
                                  >
                                    <Toggle value={i.constante === pedido.tipo_pedido} label={false}></Toggle>
                                    <span className="ui-padding-left">{i.descricao}</span>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <>
                      {pedido.quantidade > 0 && (
                        <>
                          <div className="ui-card ui-shadow ui-white ui-nopadding">
                            <div className="ui-card-title">
                              {utils.lng('seleciona_forma_entrega', 'Selecionar forma de entrega')}
                            </div>
                            <div className="ui-card-data">
                              <div className="ui-col ui-col-12">
                                {formasEntrega.map((i, index) => (
                                  <>
                                    {i.indisponivel !== true && (
                                      <>
                                        <div
                                          id={'forma_entrega_' + index}
                                          onClick={() => {
                                            if (hasConviteMesa) return;
                                            selecionarEntrega(i);
                                          }}
                                          className={
                                            'ui-forma-entrega ui-pointer ui-col ui-col-12 ' +
                                            (index % 2 === 0 ? 'ui-row-event' : 'ui-row-odd') +
                                            (i.indisponivel ? ' ui-indisponivel ' : '')
                                          }
                                        >
                                          {formasEntrega.length > 1 && (
                                            <Toggle
                                              value={i.id_entrega === pedido.id_entrega}
                                              label={false}
                                              disabled={hasConviteMesa}
                                            ></Toggle>
                                          )}
                                          <span className="ui-padding-left">{i.descricao}</span>
                                          <span className="ui-float-left ui-fix-right">
                                            <span className="ui-previsao-frete">{i.previsao ? i.previsao : ' '}</span>
                                            <span className="ui-valor-frete ui-bold">{utils.money(i.valor_frete)}</span>
                                          </span>
                                          {i.erro && <div className="ui-erro-frete">{i.erro}</div>}
                                        </div>
                                        {i.id_entrega === pedido.id_entrega && (
                                          <>
                                            {pedido.constante_entrega === 'RETIRAR_FILIAL' && (
                                              <>
                                                <div className="ui-col ui-col-12  ui-terceiros ui-padding">
                                                  <div className="ui-terceiros-data">
                                                    <div className="ui-label ui-bold">
                                                      {utils.lng('quem_vai_retirar', 'Quem vai retirar?')}
                                                    </div>
                                                    <br />
                                                    <Element
                                                      value={terceiro}
                                                      crud={crud}
                                                      data={pedido}
                                                      view={view}
                                                    ></Element>
                                                  </div>
                                                </div>
                                              </>
                                            )}
                                            {pedido.constante_entrega !== 'RETIRAR_FILIAL' &&
                                              pedido.constante_entrega !== 'DIGITAL' &&
                                              !hasConviteMesa && (
                                                <>
                                                  <div className="ui-col ui-col-12  ui-light ui-padding">
                                                    <Element
                                                      value={endereco}
                                                      crud={crud}
                                                      data={pedido}
                                                      view={view}
                                                    ></Element>
                                                  </div>
                                                </>
                                              )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  </div>
                  <div className="ui-col ui-col-4">
                    {pedido.permite_desconto && pedido.quantidade > 0 && (
                      <div
                        id="descontos_pedido"
                        style={{ marginBottom: '20px' }}
                        className="ui-card ui-shadow ui-card-resumo ui-white ui-nopadding ui-theme"
                      >
                        <div className="ui-card-title">Descontos</div>
                        <div className="ui-card-data">
                          <div className=" ui-white ui-grid">
                            <div id="desconto_dos_itens" className="ui-col ui-col-12 ui-padding">
                              <div className="ui-small-label">Desconto dos itens</div>
                              <div className="ui-value ui-bold ui-color-blue">
                                <table>
                                  <tr>
                                    <td>
                                      <CurrencyTextField
                                        autoComplete="new-password"
                                        defaultValue=""
                                        variant="outlined"
                                        currencySymbol="%"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        value={descontos.percentual_desconto_pedido}
                                        onChange={(_event, vl) =>
                                          onChangePercentualDesconto('valor_produtos', 'valor_desconto_pedido', vl)
                                        }
                                      ></CurrencyTextField>
                                    </td>
                                    <td>
                                      <CurrencyTextField
                                        autoComplete="new-password"
                                        defaultValue=""
                                        variant="outlined"
                                        currencySymbol={utils.currencySymbol()}
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        value={descontos.valor_desconto_pedido}
                                        onChange={(_event, vl) => onChangeDesconto('valor_desconto_pedido', vl)}
                                      ></CurrencyTextField>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            <div id="desconto_spv" className="ui-col ui-col-12 ui-padding">
                              <div className="ui-small-label">Desconto SPV</div>
                              <div className="ui-value ui-bold ui-color-blue">
                                <table>
                                  <tr>
                                    <td>
                                      <CurrencyTextField
                                        autoComplete="new-password"
                                        defaultValue=""
                                        variant="outlined"
                                        currencySymbol="%"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        value={descontos.percentual_desconto_spv}
                                        onChange={(_event, vl) =>
                                          onChangePercentualDesconto('valor_spv', 'valor_desconto_spv', vl)
                                        }
                                      ></CurrencyTextField>
                                    </td>
                                    <td>
                                      <CurrencyTextField
                                        autoComplete="new-password"
                                        defaultValue=""
                                        variant="outlined"
                                        currencySymbol={utils.currencySymbol()}
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        value={descontos.valor_desconto_spv}
                                        onChange={(_event, vl) => onChangeDesconto('valor_desconto_spv', vl)}
                                      ></CurrencyTextField>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            <div id="confirma_desconto" className="ui-col ui-col-12 ui-padding noborder">
                              <div className="ui-small-label"></div>
                              <div className="ui-value ui-bold ui-color-blue">
                                <Button onClick={aplicarDescontos} variant="contained">
                                  APLICAR DESCONTOS
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {pedido.quantidade > 0 && (
                      <>
                        <div
                          id="resumo_pedido"
                          className="ui-card ui-shadow ui-card-resumo ui-white ui-nopadding ui-theme"
                        >
                          <div className="ui-card-title">{utils.lng('resumo_pedido', 'Resumo do pedido')}</div>
                          <div className="ui-card-data">
                            <div className=" ui-white ui-grid">
                              <div id="valor_dos_itens" className="ui-col ui-col-12 ui-padding">
                                <div className="ui-small-label">{utils.lng('valor_itens', 'Valor dos itens')}</div>
                                <div id="valor_produtos" className="ui-value ui-bold ui-color-blue">
                                  {pedido.exibir_centavos
                                    ? utils.money(pedido.valor_produtos)
                                    : utils.moneyCents(pedido.valor_produtos)}
                                </div>
                              </div>
                              {pedido.exibir_spv && (
                                <>
                                  <div className="ui-col ui-col-12 ui-padding">
                                    <div className="ui-small-label">{utils.lng('valor_spv', 'SPV')}</div>
                                    <div id="valor_spv" className="ui-value ui-bold ui-color-blue">
                                      {pedido.exibir_centavos
                                        ? utils.money(pedido.valor_spv)
                                        : utils.moneyCents(pedido.valor_spv)}
                                    </div>
                                  </div>
                                </>
                              )}
                              {pedido.exibir_valor_moeda_secundaria && (
                                <>
                                  <div className="ui-col ui-col-12 ui-padding">
                                    <div className="ui-small-label">{pedido.descricao_moeda_secundaria}</div>
                                    <div id="valor_moeda_secundaria_2" className="ui-value ui-bold ui-color-blue">
                                      {utils.customMoney('₲', pedido.valor_custo)}
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="ui-col ui-col-12 ui-padding">
                                <div className="ui-small-label">{utils.lng('frete_label', 'Frete')}</div>
                                <div id="valor_frete" className="ui-value ui-bold ui-color-green">
                                  {pedido.valor_frete <= 0 && <>{utils.lng('gratis', 'Grátis')}</>}
                                  {pedido.valor_frete > 0 && (
                                    <>
                                      {pedido.exibir_centavos
                                        ? utils.money(pedido.valor_frete)
                                        : utils.moneyCents(pedido.valor_frete)}
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className="ui-col ui-col-12 ui-padding">
                                <div className="ui-small-label">{utils.lng('descontos', 'Descontos')}</div>
                                <div id="valor_desconto" className="ui-value ui-bold ui-color-red">
                                  {pedido.exibir_centavos
                                    ? utils.money(pedido.valor_descontos)
                                    : utils.moneyCents(pedido.valor_descontos)}
                                </div>
                              </div>
                              <div className="ui-col ui-col-12 ui-padding">
                                <div className="ui-small-label">{utils.lng('valor_total', 'Valor total')}</div>
                                <div id="valor_total_pedido" className="ui-value ui-bold ui-color-green ">
                                  {pedido.exibir_centavos
                                    ? utils.money(pedido.valor_total)
                                    : utils.moneyCents(pedido.valor_total)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="ui-finalizar">
                  <Element value={confirmar} crud={crud} data={pedido} view={view}></Element>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <Dialog
        open={showDialogQrCodePix}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={false}
        maxWidth={false}
        PaperProps={{ style: { width: '100%', height: '85%' } }}
      >
        <DialogTitle id="alert-dialog-title">{utils.lng('pagto_via_pix', 'Pagamento via PIX')}</DialogTitle>
        <DialogContent>
          <div id="pagto_pix" className="pix-card">
            <>
              {isPagamentoPixAprovado && (
                <div style={{ height: '90%', width: '100%', paddingTop: '10%' }}>
                  <i class="fas fa-check-circle fa-10x" style={{ color: 'green', float: 'center' }}></i>
                  <span id="span_pix_confirmacao" className="pix-confirmacao pix-header">
                    {utils.lng('pagamento_aprovado', 'Pagamento Aprovado!')}
                  </span>
                </div>
              )}
              {!isPagamentoPixAprovado && (
                <div style={{ height: '90%', width: '100%' }}>
                  <span className="pix-header">
                    {' '}
                    {utils.lng('pedido_realizado_sucesso', 'Seu pedido foi realizado com sucesso!')}{' '}
                  </span>

                  <span className="pix-instrucoes-qr-code-box">
                    <span className="pix-instrucoes-qr-code">
                      {' '}
                      {utils.lng(
                        'pix_instrucoes_pix_1',
                        '1. Abra o app de seu banco ou instituição financeira e entre no ambiente Pix.',
                      )}{' '}
                    </span>
                    <span className="pix-instrucoes-qr-code">
                      {' '}
                      {utils.lng(
                        'pix_instrucoes_pix_2',
                        '2. Escolha a opção Pagar com QR Code e escaneie o código abaixo.',
                      )}{' '}
                    </span>
                    <span className="pix-instrucoes-qr-code">
                      {' '}
                      {utils.lng('pix_instrucoes_pix_3', '3. Confirme as informações e finalize o pagamento.')}{' '}
                    </span>
                  </span>

                  <span className="pix-dados-pedido-box">
                    <span className="pix-dados-pedido-text">
                      {' '}
                      {utils.lng('pedido', 'Pedido') + ': ' + pedido.numero_pedido}{' '}
                    </span>
                    <span className="pix-dados-pedido-text">
                      {' '}
                      {utils.lng('valor_compra', 'Valor da compra') + ': ' + utils.money(pedido.valor_total)}{' '}
                    </span>
                    <span className="pix-dados-pedido-text">
                      {' '}
                      {utils.lng('expira_em', 'Expira em') + ': ' + (pgtoPix ? pgtoPix.info_expiracao : '')}{' '}
                    </span>
                  </span>
                  <img
                    className="pix-qrcode"
                    src={
                      utils.getUrlApi() +
                      '/qrcode.png?access_token=' +
                      utils.getToken() +
                      '&text=' +
                      (pgtoPix ? pgtoPix.info_qrcode : '') +
                      '&width=300&height=300'
                    }
                  ></img>

                  <div className="ui-col-12 pix-header ui-center">
                    <span className="pix-instrucoes-copia-cola">
                      {' '}
                      {utils.lng(
                        'pix_instrucoes_copia_cola',
                        'Você também pode pagar através do pix Copia e Cola acessando seu internet banking e usando o código abaixo:',
                      )}{' '}
                    </span>
                    <span id="span_pix_copia_cola" className="pix-copia-cola-codigo">
                      {' '}
                      {pgtoPix ? pgtoPix.info_pix_copia_cola : ''}{' '}
                    </span>
                    <span className="pix-copia-cola-button">
                      <a
                        id="copy_codigo_pix"
                        className="ui-button-link"
                        onClick={() => {
                          utils.copy('span_pix_copia_cola');
                        }}
                      >
                        {utils.lng('copiar_codigo_pagamento', 'COPIAR CÓDIGO PARA PAGAMENTO')}
                      </a>
                    </span>
                  </div>
                </div>
              )}
            </>
          </div>
        </DialogContent>
        <DialogActions rendered={falhaConfirmacaoPix === true}>
          <Button id="btnFechar" onClick={crud.switchDialogQrCodePix} variant="contained" color="secondary">
            {utils.lng('fechar', 'Fechar')}
          </Button>
          <Button id="btnConsultar" onClick={buscaConfirmacaoPix} variant="outlined" color="secondary">
            {utils.lng('atualizar', 'Atualizar')}
          </Button>
        </DialogActions>
      </Dialog>
      <DialogMesasEvento
        open={openDialogMesas}
        onClose={() => {
          setOpenDialogMesas(false);

          if (quantidadeMesaAlteradaRef.current) {
            quantidadeMesaAlteradaRef.current = false;
            refreshPedido();
          }
        }}
        id_pedido={pedido.id_pedido || idPedido}
        quantidade={quantidadeConvites}
        id_sku={itemConviteMesa?.id_sku}
        id_hub_ped_venda_item={
          itemConviteMesa?.id_hub_ped_venda_item ||
          itemConviteMesa?.id_ped_venda_item ||
          itemConviteMesa?.id_item ||
          itemConviteMesa?.id
        }
        crud={crud}
        mesasReservadas={mesasReservadas}
        onQuantidadeAlterada={() => {
          quantidadeMesaAlteradaRef.current = true;
          refreshItensCarrinho();
        }}
        onSave={(mesasSelecionadas) => setMesasReservadas(mesasSelecionadas)}
      />
      <DialogLinksPagamento
        open={openDialogLinks}
        onClose={() => setOpenDialogLinks(false)}
        id_hub_ped_venda_pgto={pagamentoLinkExterno?.id}
        crud={crud}
      />
    </View>
  );
}

export default Pedido;
